/* TODO: t() */
import React from 'react';
import {
  CheckBox as CheckboxNative,
  View,
  StyleSheet,
  StyleProp,
  TextStyle,
} from 'react-native';

import { themeColors } from './Constants';
import Text from './Text';
import { useTabIndex } from '../../support/rn-web/helpers/useTabIndex';

type Props = {
  isChecked: boolean;
  text?: string;
  textStyle?: StyleProp<TextStyle>;
  style?: StyleSet;
  tabIndex?: number;
  isDisabled?: boolean;
  onChange?: (value: boolean) => void;
  testID?: string;
};

export function Checkbox(props: Props) {
  let {
    isChecked,
    text,
    textStyle,
    style,
    tabIndex,
    isDisabled,
    onChange,
    testID,
  } = props;
  let ref = useTabIndex(tabIndex);
  return (
    <View accessibilityRole="label">
      <View style={[styles.textWrapper, style]}>
        <CheckboxNative
          ref={ref as never}
          testID={testID}
          value={!!isChecked}
          onValueChange={onChange}
          disabled={isDisabled}
          color={themeColors.blue}
        />
        <Text type="label" numberOfLines={1} style={[styles.text, textStyle]}>
          {text}
        </Text>
      </View>
    </View>
  );
}

let styles = StyleSheet.create({
  textWrapper: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingLeft: 2,
    paddingRight: 15,
    paddingVertical: 8,
  },
  text: {
    paddingLeft: 10,
    fontWeight: 'normal',
  },
});

export default Checkbox;
